import { render, staticRenderFns } from "./DesktopDashboard.vue?vue&type=template&id=0ea4424c&scoped=true&"
import script from "./DesktopDashboard.vue?vue&type=script&lang=ts&"
export * from "./DesktopDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./DesktopDashboard.vue?vue&type=style&index=0&id=0ea4424c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea4424c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCheckbox,VIcon,VSelect,VTooltip})
